<template>
  <div class="w-full">
    <div v-for="(filterGroup, groupIndex) in filterGroups" :key="`group_`+groupIndex" class="border p-2 rounded w-full mt-2">
      <div class="mt-2 mb-2 flex border p-2">
        <select v-model="filterGroup.inclusive" class="w-full border focus:border-grey-darkest p-2">
          <option :value="true">Any one of the following are included..</option>
          <option :value="false">None of the following are included..</option>
        </select>
        <button title="Remove Filter Group" @click="confirmDeleteFilterGroup = groupIndex" class="text-tertiary mx-2">
          <i class="far fa-trash-alt fa-fw"></i>
        </button>
      </div>
      <div v-for="(referralApplicantFilter, filterIndex) in filterGroup.referralApplicantFilters" :key="filterIndex">
        <div class="w-full">
          <div class="bg-grey-lighter py-2 px-2 border-l-4 border-r-4 hover:border-grey">
            <div class="relative">
              <div class="flex items-center -mx-2">
                <div class="flex-grow px-2">
                  <span v-if="referralApplicantFilter">{{ referralApplicantFilter }}</span>
                  <span v-else class="text-grey-dark">(blank)</span>
                </div>
                <div class="flex justify-end">
                  <button @click="removeFilterInGroup(groupIndex, filterIndex, referralApplicantFilter)" class="text-tertiary mx-2">
                    <i class="far fa-trash-alt fa-fw"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span v-if="filterGroup.deletedReferralApplicantFilters && filterGroup.deletedReferralApplicantFilters.length > 0">
      <div v-for="(deletedReferralApplicantFilter, deletedReferralApplicantFilterIndex) in filterGroup.deletedReferralApplicantFilters" :key="`inactive_`+deletedReferralApplicantFilterIndex">
        <div class="w-full">
          <div class="text-red-dark  bg-red-lightest py-2 px-2 border-l-4 border-r-4 hover:border-red">
            <div class="relative">
              <div class="flex items-center -mx-2">
                <div class="flex-grow px-2 line-through">
                  <span v-if="deletedReferralApplicantFilter"><small>{{ deletedReferralApplicantFilter }}</small></span>
                </div>
                <div class="flex justify-end">
                  <button @click="restoreFilterInGroup(groupIndex, deletedReferralApplicantFilterIndex, deletedReferralApplicantFilter)" class="text-tertiary mx-2" title="Restore">
                    <i class="fas fa-trash-restore"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </span>
      <div class="mt-4">
        <span>
          <button @click="openModal(groupIndex)">+ Add custom position</button>
        </span>
      </div>
    </div>
    <div class="flex flex-wrap mt-4">
      <div class="flex-1 w-full lg:w-1/2">
        <button @click="addNewFilterGroup" class="ml-1" :disabled="filterGroups.length >= 2" :class="filterGroups.length >= 2 ? 'pointer-events-none' : ''">
          + Add filter group
        </button>
      </div>
    </div>
    <deletion-modal
      v-if="confirmDeleteFilterGroup !== null"
      :loading="cancellingDeleteFilterGroup"
      @confirmed="removeFilterGroup"
      @leave="confirmDeleteFilterGroup = null"
      @dismissed="confirmDeleteFilterGroup = null"
      confirm-label="Yes, Delete it."
    >
      <p class="text-center">Are you sure you wish to delete this filter group?</p>
    </deletion-modal>
    <referral-applicant-filter-modal
      v-if="isModalVisible"
      @leave="isModalVisible = false"
      @saveFilter="addCustomFilter"
    />
  </div>
</template>

<script>
import DeletionModal from '@/components/Modals/DeletionModal'
import ReferralApplicantFilterModal from '@/components/ReferralApplicantFilterModal.vue'
import { mapActions } from 'vuex'
export default {
  name: 'ReferralApplicantFilters',
  components: { DeletionModal, ReferralApplicantFilterModal },
  props: {
    filterGroups: {
      type: Array,
      required: true
    },
    typeId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      confirmDeleteFilterGroup: null,
      cancellingDeleteFilterGroup: false,
      isModalVisible: false,
      groupIndex: null,
      errorMessage: ''
    }
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    addCustomFilter (newFilter) {
      if (this.groupIndex !== null) {
        const group = this.filterGroups[this.groupIndex]
        if (this.hasDuplicate(newFilter)) {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Error',
            info: 'A custom position with this name already exists in the group'
          })
          return
        }
        group.referralApplicantFilters.push(newFilter.trim())
      }
      this.isModalVisible = false
    },
    addNewFilterGroup () {
      this.filterGroups.push({
        inclusive: true,
        referralApplicantFilters: []
      })
    },
    removeFilterInGroup (groupIndex, filterIndex, filter) {
      const group = this.filterGroups[groupIndex]
      group.referralApplicantFilters.splice(filterIndex, 1)
      if (!group.deletedReferralApplicantFilters) {
        group.deletedReferralApplicantFilters = []
      }
      group.deletedReferralApplicantFilters.push(filter)
    },
    removeFilterGroup (groupIndex) {
      this.filterGroups.splice(groupIndex, 1)
      this.confirmDeleteFilterGroup = null
    },
    emitFilterData () {
      this.$emit('updatereferralApplicantFilters', this.filterGroups)
    },
    openModal (groupIndex = null) {
      this.groupIndex = groupIndex
      this.isModalVisible = true
    },
    hasDuplicate (filterName) {
      const group = this.filterGroups[this.groupIndex]
      return group.referralApplicantFilters.some(existingFilter =>
        existingFilter === filterName || (existingFilter === null && filterName === '')
      )
    },
    restoreFilterInGroup (groupIndex, deletedIndex) {
      const group = this.filterGroups[groupIndex]
      const restoredFilter = group.deletedReferralApplicantFilters.splice(deletedIndex, 1)[0]
      group.referralApplicantFilters.push(restoredFilter)
    }
  }
}
</script>
